import { memo, useMemo } from "react";

import { Box } from "@hightouch/htui";

import { MarkdownStaticHtml } from "src/components/markdown-editor";
import type { AmpLibraryFileFragment } from "src/graphql";
import { renderDocHtml } from "src/pages/projects/library/files/doc-html";

/** The doc editor's page width (sizes 3xl); a miniature lays out at it and scales down. */
const DOC_PAGE_WIDTH = 768;

/** A doc as its editor shows it, at the editor's own width and padding, scaled down to `width` px. */
export const DocMiniature = memo(function DocMiniature({
  file,
  width,
}: {
  file: AmpLibraryFileFragment;
  width: number;
}) {
  const markdown = file.markdown?.markdown ?? "";
  const html = useMemo(() => renderDocHtml(markdown), [markdown]);
  return (
    <Box
      width={`${DOC_PAGE_WIDTH}px`}
      px={14}
      pt={12}
      transform={`scale(${width / DOC_PAGE_WIDTH})`}
      transformOrigin="top left"
    >
      <MarkdownStaticHtml html={html} />
    </Box>
  );
});
